import { ProfileActions } from '@app-core/store/actions/profile/actions';
import { MaritalStatus } from '@app-models/marital-status.model';
import { UserInformation } from '@app-models/user.model';
import { createAction, props } from '@ngrx/store';

export const setProfile = createAction(
  ProfileActions.SET_PROFILE,
  props<{ user: UserInformation }>()
);

export const clearProfile = createAction(ProfileActions.CLEAR_PROFILE);

export const setOptionsProfile = createAction(
  ProfileActions.SET_OPTIONS_PROFILE,
  props<{
    maritalStatuses: MaritalStatus[];
  }>()
);

export const loadProfileOptions = createAction(
  ProfileActions.LOAD_PROFILE_OPTIONS
);

export const loadProfile = createAction(
  ProfileActions.LOAD_PROFILE,
  props<{ userId: number }>()
);
